import { EventAccess } from "@components/Accesses/AccessDetails/types";
import Button from "../common/Button";
import LIcon from "@components/LIcon";
import LText from "@components/LText";
import { router } from "expo-router";
import { useNavigationStore } from "@utils/navigation/useNavigationStore";
import { useEffect } from "react";
import { useBottomSheetManager } from "react-native-bottom-sheet-stack";
import { EngineTicketsSheet } from "../checkout/EngineTicketsSheet";

const RegisterInternal = ({
  access,
  recentlyPurchased = false,
}: {
  access: EventAccess;
  recentlyPurchased: boolean;
}) => {
  const isFree = access.priceMin === 0;
  const minimumAmount = (access.price ?? 0) + (access.bookingFee ?? 0);
  const isPayWhatYouWant = !!minimumAmount && !access.priceMax;

  const reload = useNavigationStore((state) => state.reload);
  const bottomSheetManager = useBottomSheetManager();

  const nextRoute =
    isFree && !isPayWhatYouWant
      ? "/(app)/access/[accessId]/tickets"
      : "/(app)/access/[accessId]/checkout";

  // Engine events pick tickets in a sheet stacked over the Details; the
  // /tickets and /checkout routes stay for deep links and legacy accesses.
  const open = () => {
    if (access.engineEventId) {
      bottomSheetManager.open(<EngineTicketsSheet accessId={access.id} />, {
        mode: "push",
      });
      return;
    }
    router.push({
      pathname: nextRoute,
      params: { accessId: access.id },
    });
  };

  useEffect(() => {
    if (reload) open();
  }, [reload]);

  return (
    <Button.Button
      onPress={open}
      sentryEventName="AccessDetail.Register"
      bg={"white"}
    >
      <LIcon colors={{ color: "black" }} name="ticket" size={16} />
      <LText variant="Caption/C1/Medium" color={"black"}>
        {access.isWaitlist
          ? recentlyPurchased
            ? "Waitlisted"
            : "Join Waitlist"
          : access.engineEventId
            ? "Get tickets"
            : "Register"}
      </LText>
    </Button.Button>
  );
};

export default RegisterInternal;
